import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import RoleItem from "./RoleItem";
import { AuthContext } from "../context/AuthContext";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";

const Roles = (props) => {
  const onSubmitRole = props.onSubmitRole;
  const handleRemoveRole = props.handleRemoveRole;
  const updateRole = props.updateRole;
  const [role, setRole] = useState({ name: "", stars: null });
  const roles = props.roles;
  const [editing, setEditing] = useState(false);
  const authContext = useContext(AuthContext);
  const [inputError, setInputError] = useState({
    state: false,
    message: "",
  });
  const history = useHistory();

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    setRole({ name: e.target.value });
  };
  const onSubmitValidation = (e) => {
    e.preventDefault();
    if (role.name === "") {
      setInputError({ state: true, message: "Please enter a role" });
    } else {
      setInputError({ state: false, message: "" });
      onSubmitRole(e, role);
      setRole({ name: "", stars: 0 });
    }
  };

  return (
    <Paper
      elevation={3}
      style={{
        marginTop: "20px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: !props.onMobile ? "48.5%" : "100%",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "roles")}</h4>
          {!editing && (
            <IconButton
              onClick={() => setEditing(true)}
              variant="outlined"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          )}
          {editing && (
            <IconButton
              onClick={() => {
                setInputError({ state: false, message: "" });
                setEditing(false);
              }}
              variant="outlined"
              color="primary"
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        {roles === undefined || roles.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {getProfileLabel(props.profileLanguage, "noRoles")}
          </p>
        ) : (
          roles.map((role) => {
            return (
              <RoleItem
                key={role._id}
                role={role}
                updateRole={(e, role) => updateRole(e, role)}
                removeRole={() => handleRemoveRole(role)}
                editing={editing}
              />
            );
          })
        )}
      </div>
      {editing && (
        <form
          onSubmit={(e) => {
            onSubmitValidation(e);
          }}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            error={inputError.state}
            type="text"
            name="Role"
            label="Enter Role"
            value={role.name}
            onChange={onChange}
            className="form-cotrol"
            style={{ margin: "20px 0px 10px 0px" }}
            helperText={inputError.message}
          />
          <Button type="submit" variant="outlined" color="primary">
            Add Role
          </Button>
        </form>
      )}
    </Paper>
  );
};

export default Roles;
